<template>
  <div>

    <div class="panel">
      <b-button v-b-modal.help-modal>Help</b-button>

      <b-button
        v-if="mayManageQAUsers"
        :to="{name: 'qa_user_add'}"
        variant="primary"
      >
        New QA user
      </b-button>
    </div>

    <loading-indicator v-if="isLoading"></loading-indicator>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="isDataLoaded && qaUsers.length > 0" class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Id type</th>
          <th scope="col">Id value</th>
          <th scope="col">Description</th>
          <th
            scope="col"
            v-if="mayManageQAUsers"
          >
            Actions
          </th>
        </tr>
      </thead>
        <tr
          v-for="qaUser in qaUsers"
          :key="qaUser.idType + '_' + qaUser.idValue"
        >
          <td>
            {{qaUser.idType | getQAUserIdTypeStr}}
          </td>
          <td>
            {{qaUser.idValue}}
          </td>
          <td>
            {{qaUser.description}}
          </td>
          <td
            v-if="mayManageQAUsers"
          >
            <b-button
              :to="{name: 'qa_user_edit', params: {idType: qaUser.idType, idValue: qaUser.idValue}}"
              size="sm"
            >
              Edit
            </b-button>
            <b-button @click='deleteQAUserWithConfirmation(qaUser)' variant="danger" size="sm">Delete</b-button>
          </td>
        </tr>
    </table>

    <b-modal id="help-modal" title="Справка по тестировщикам" ok-only ok-title="Close">
      <div class="help">
        <p>
          Платежи тестировщиков на проде не учитываются в&nbsp;статистике.
        </p>
        <p>
          Можно указать тестировщика по Player&nbsp;ID — тогда на каком бы устройстве он ни восстановил свой мир,
          он будет считаться тестировщиком.
        </p>
        <p>
          Можно указать тестировщика по Facebook&nbsp;ID — тогда любой из игровых «миров»
          на любом устройстве будет считаться тестовым,
          если игра залогинена в Facebook под этим Facebook&nbsp;ID.<br>
          Важно — после логина в Facebook надо перезапустить игру.<br>
          Facebook&nbsp;ID можно посмотреть в инсайдере на странице игрока.
        </p>
        <p>
          Можно указать тестировщика по Advertising&nbsp;ID (Ads&nbsp;ID) — тогда вне зависимости
          от&nbsp;Player&nbsp;ID и&nbsp;Facebook&nbsp;ID
          профиль будет считаться тестовым, когда играешь с устройства с&nbsp;таким Advertising&nbsp;ID.
        </p>
        <p>
          Посмотреть/скопировать/переслать Advertising&nbsp;ID можно с&nbsp;помощью приложения My Device ID.
        </p>
        <ul>
          <li><a href="https://apps.apple.com/us/app/my-device-id-by-appsflyer-whitelist-test-device/id1192323960">https://apps.apple.com/us/app/my-device-id-by-appsflyer-whitelist-test-device/id1192323960</a></li>
          <li><a href="https://play.google.com/store/apps/details?id=com.appsflyer.android.deviceid&hl=en">https://play.google.com/store/apps/details?id=com.appsflyer.android.deviceid&amp;hl=en</a></li>
        </ul>
      </div>
    </b-modal>

  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import { mayManageQAUsers as utilMayManageQAUsers } from '../util';

export default {
  name: 'QAUsers',

  components: {
    LoadingIndicator,
  },

  data() {
    return {
      actor: auth.getViewer(),
      isLoading: false,
      qaUsers: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isDataLoaded() {
      return this.qaUsers !== null;
    },

    /** @returns {?string} */
    message() {
      if(this.qaUsers !== null && this.qaUsers.length === 0) {
        return 'No QA users.';
      }
      return null;
    },

    /** @returns {boolean} */
    mayManageQAUsers() {
      return utilMayManageQAUsers(this.actor.role);
    },
  },

  created() {
    this.isLoading = true;
    HTTP.get('/qa_users')
    .then(response => {
      this.qaUsers = [];
      for(var i = 0; i < response.data.data.length; ++i) {
        const qaUser = response.data.data[i];
        this.qaUsers.push(qaUser);
      }
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

  methods: {
    deleteQAUserWithConfirmation(qaUser) {
      this.confirmQAUserDeletion(() => {
        this.deleteQAUser(qaUser);
      });
    },

    // function onConfirmed()
    confirmQAUserDeletion(onConfirmed) {
      this.$bvModal.msgBoxConfirm(
        'Are you sure you want to delete this QA user?',
        {
          okTitle: 'Delete',
          okVariant: 'danger',
        }
      )
      .then(confirmed => {
        if(confirmed) {
          onConfirmed();
        }
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    deleteQAUser(qaUser) {
      notifier.deleteSenderNotifications(this);

      const data = new FormData();
      data.append('id_type', qaUser.idType);
      data.append('id_value', qaUser.idValue);

      HTTP.post('/qa_user/del', data)
      .then(() => {
        const index = this.qaUsers.indexOf(qaUser);
        if(index !== -1) {
          this.qaUsers.splice(index, 1);
        }
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>

<style scoped>
.panel {
  margin-bottom: 1em;
}

.help p, .help ul {
  max-width: 600px;
  margin-bottom: 0.8rem;
}

.help p + ul {  
   margin-top: -0.8rem;
}

.help :last-child {
  margin-bottom: 0px;
}
</style>
